<template>
  <div class="q-ma-xs row justify-center">
    <q-card class="justify-center" flat>
      <q-card-section v-for="(perk, index) in perks" :key="index">
        <perks-card :perk="perk" cssclass="row q-px-md q-gutter-md" :list="true" :points="perk.points" :perks="perk.place.pointsToPerk" :merchant="merchant" :updatedAtAgo="perk.updatedAt"  />
      </q-card-section>
      <q-card-section v-if="(perks.length === 0 || !perks) && !home">
        <q-banner inline-actions rounded outline class="bg-white text-primary">
          <template v-slot:avatar>
            <q-icon name="info" />
          </template>
          <p v-if="!merchant">You haven't earned any points yet.</p>
          <p v-else>You haven't given anyone points yet.</p>
        </q-banner>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import PerksCard from "./PerksCard.vue";
export default {
  name: 'perks-list',
  props: ['perks', 'class', 'merchant', 'home'],
  components: {PerksCard}
}
</script>
